export enum TipoMovimiento {
  none,
  "Activaciones",
  "Renuévate",
  "Portabilidad",
  "Chip 0",
}
